<template>
    <div>

    </div>
</template>

<script>
    export default {
        name: "OtherService"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/page/ValueAddManage/OtherService.vue